import React from "react";

interface Props {
  /** Specify the color option */
  color?: "primary" | "secondary" | "alert" | "light" | "disabled" | "custom";

  /** Specify the Tag size */
  size?: "xsmall" | "large" | "medium" | "small" | "chip";

  /** Displays a short descriptive keyword in a pill container */
  children: string;

  /** Specify the testid for current component */
  "data-testid"?: string;

  /** Custom color for tag if color is custom (site wide promo) */
  customColor?: string | null;
}

export const DescriptiveTag: React.FC<Props> = ({
  color = "primary",
  size = "medium",
  children,
  customColor = null,
  "data-testid": dataTestId,
}) => {
  const sizes = {
    xsmall:
      "min-w-[16px] min-h-[16px] px-0.5 rounded-full text-[10px] leading-none",
    small: "text-chip uppercase py-1 px-1.5",
    medium: "text-bold3 py-1 px-2",
    large: "text-bold1 px-4 py-1.5",
    chip: "text-chip uppercase py-1 px-1.5",
  };

  const colors = {
    primary: "bg-brand-color text-white",
    secondary: "bg-brand-color/10 text-brand-color",
    alert: "text-white bg-text-primary",
    light: "bg-white text-dark",
    disabled: "bg-background-two text-dark-grey",
    custom: `bg-${customColor} text-white`,
  };

  return (
    <div
      style={{ backgroundColor: customColor || undefined }}
      className={`${
        size === "xsmall"
          ? "flex items-center justify-center"
          : "flex w-fit flex-none items-center gap-1.5"
      } rounded font-sans ${sizes[size]} ${colors[color]}`}
      data-testid={dataTestId}
    >
      {color === "alert" && (
        <div className="h-2.5 w-2.5 rounded-full bg-red">
          <div className="h-full w-full animate-ping rounded-full bg-inherit" />
        </div>
      )}
      {children}
    </div>
  );
};
